import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

window.onload = () => {
	if (window.location.href.endsWith('/tickets/')) {
	  const orderTicketsContainer = document.querySelector('#orderTicketsContainer');
	  if (orderTicketsContainer) {
		 window.scrollTo({ top: orderTicketsContainer.offsetTop, behavior: 'smooth' });
	  }
	}
 };


export default class ButtonRegister {
  constructor(element) {
    this.element = element;
    this.init();
	 this.addEventListeners();
  }

  init() {
    ScrollTrigger.create({
      trigger: this.element,
      start: 'top top',

      onEnter: () => {
        this.element.classList.add('is-sticky');
		  document.querySelector('.nav-logo').classList.add('is-sticky');
      },

      onLeaveBack: () => {
        this.element.classList.remove('is-sticky');
		  document.querySelector('.nav-logo').classList.remove('is-sticky');
      }
    });
  }
	addEventListeners() {
		this.element.addEventListener('click', (event) => {
			event.preventDefault();
			document.querySelectorAll('#orderTicketsContainer').forEach((el) => {
				if ( this.element.classList.contains('is-sticky') ) {
					scrollTo({	top: el.offsetTop, behavior: 'smooth' });
					el.classList.remove('hide');
				} else {
					el.classList.toggle('hide');
				}
			});
		});
	}
}
